import { render, staticRenderFns } from "./VMultiSelect.vue?vue&type=template&id=370efb46&scoped=true"
import script from "./VMultiSelect.vue?vue&type=script&lang=ts"
export * from "./VMultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./VMultiSelect.vue?vue&type=style&index=0&id=370efb46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370efb46",
  null
  
)

export default component.exports